import Chip from '@components/v2/ui/Chip/Chip';
import Icon from '@components/v2/ui/Icon/Icon';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box } from '@mui/material';
import { ChevronDown, ChevronUp, Link2 } from 'lucide-react';
import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../translation/TranslationContext';
import { DocLinkBlock as DocLinkBlockType } from '../../viz.types';
import { useDocLinkBlockStyles } from './docLinkBlock.styles';
import { useDocLinkBlock } from './useDocLinkBlock';

interface DocLinkBlockProps {
  block: DocLinkBlockType;
}

const DocLinkBlock = ({ block }: DocLinkBlockProps) => {
  const { translate } = useTranslation();
  const { links, isExpanded, toggle } = useDocLinkBlock(block);
  const { classes } = useDocLinkBlockStyles();

  if (links.length === 0) {
    return null;
  }

  const toggleHint = translate(isExpanded ? LangEnum.GLOBAL_SHOW_LESS : LangEnum.GLOBAL_SHOW_MORE);

  return (
    <Box className={classes.root}>
      <Box
        component="button"
        type="button"
        className={classes.toggle}
        onClick={toggle}
        title={toggleHint}
        aria-expanded={isExpanded}
      >
        <Typography variant="body2" color="inherit">
          {translate(LangEnum.RACHEL_DOC_LINKS_TITLE)}
        </Typography>
        <Icon icon={isExpanded ? ChevronUp : ChevronDown} size="sm" />
      </Box>
      {isExpanded && (
        <Box className={classes.row}>
          {links.map((link) => (
            <Box
              key={link.url}
              component="a"
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.link}
            >
              <Chip
                size="small"
                icon={<Icon icon={Link2} size="xs" />}
                label={link.title}
                title={link.title}
                className={classes.chip}
                clickable
              />
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default DocLinkBlock;
